export default __webpack_public_path__ + "static/media/zoi-black.5ef64e3c.png";